import { Box, Typography } from "@mui/material"
import { ErrorOutline } from "@mui/icons-material"

import "./style.scss"

interface ErrorProps {
  error: string | null
}

export default function Error({ error }: ErrorProps) {
  if (!error) {
    return null
  }

  return (
    <Box className="components_error">
      <Box className="error-content">
        <ErrorOutline className="error-icon" />
        <Typography className="error-message">
          {error}
        </Typography>
      </Box>
    </Box>
  )
}
